<template>
  <div class="page">
    <div class="container">

      <element-processor @submit="submit" :data="processorData" @submitOtherEst="submitOtherEst">
        <element-processor-step :data="processorData.steps[0]">
          <ul class="form-item-list">
            <li><h3>고객 정보</h3></li>
            
            <template v-if="false">
              <!-- 주석처리하지 않고 보이지 않도록 설정함. -->
              <li><element-textbox v-model="processorData.steps[0].formData.name.value" :error="processorData.steps[0].formData.name.error" :label="processorData.steps[0].formData.name.label" :placeholder="processorData.steps[0].formData.name.label" /></li>
            </template>

            <li><element-spread-select v-model="processorData.steps[0].formData.sex.value" :error="processorData.steps[0].formData.sex.error" :label="processorData.steps[0].formData.sex.label" :items="processorData.steps[0].formData.sex.items" /></li>
            <li><element-textbox v-model="processorData.steps[0].formData.birth.value" :error="processorData.steps[0].formData.birth.error" :label="processorData.steps[0].formData.birth.label" :placeholder="processorData.steps[0].formData.birth.placeholder" /></li>
            <div class="form-item-caution">정확한 보험료 산출을 위해 활용됩니다.</div>
          </ul>
          <ul class="form-item-list">
            <li><element-spread-select v-model="processorData.steps[0].formData.job.value" :error="processorData.steps[0].formData.job.error" :label="processorData.steps[0].formData.job.label" :items="processorData.steps[0].formData.job.items" /></li>
          </ul>
          <div class="form-item-caution">찾는 직업이 없는경우, 가장 비슷한 직업으로 선택하신 후 상담예약에 내용을 남겨주시면 해당하는 직업으로 변경해 드립니다.</div>
        </element-processor-step>
        <element-processor-step :data="processorData.steps[1]">
          <ul class="form-item-list">
            <li><h3>보장항목</h3></li>
            <li><element-select v-model="processorData.steps[1].formData.insureDuration.value" :error="processorData.steps[1].formData.insureDuration.error" :label="processorData.steps[1].formData.insureDuration.label" :placeholder="processorData.steps[1].formData.insureDuration.placeholder" :items="processorData.steps[1].formData.insureDuration.items" /></li>
            <li
              :key="index"
              v-for="(options, index) in processorData.steps[1].formData.insureOptions"
            >
              <element-content-checkbox
                @status="popup"
                v-model="processorData.steps[1].formData.insureOptions[index].value"
                :error.sync="processorData.steps[1].formData.insureOptions[index].error"
                :label="processorData.steps[1].formData.insureOptions[index].label"
                :items="processorData.steps[1].formData.insureOptions[index].items"
                :index="index"
                :requirement="processorData.steps[1].formData.insureOptions[index].requirement"
              />
            </li>
          </ul>
        </element-processor-step>
        <element-processor-step :data="processorData.steps[2]">
          <ul class="form-item-list" id="history-of-treatment">
            <li><h3>치료이력</h3></li>
            
            <li><element-textbox v-model="processorData.steps[2].formData.name.value" :error="processorData.steps[2].formData.name.error" :label="processorData.steps[2].formData.name.label" :placeholder="processorData.steps[2].formData.name.label" /></li>
            <li><element-textbox v-model="processorData.steps[2].formData.birth.value" :error="processorData.steps[2].formData.birth.error" :label="processorData.steps[2].formData.birth.label" :placeholder="processorData.steps[2].formData.birth.placeholder" /></li>

            <li id="history-of-treatment-item"><element-radio v-model="processorData.steps[2].formData.history.value" :error="processorData.steps[2].formData.history.error" :label="processorData.steps[2].formData.history.label" :items="processorData.steps[2].formData.history.items" /></li>
            <li id="history-of-treatment-item"><element-radio v-model="processorData.steps[2].formData.inject.value" :error="processorData.steps[2].formData.inject.error" :label="processorData.steps[2].formData.inject.label" :items="processorData.steps[2].formData.inject.items" /></li>
            <li id="history-of-treatment-item"><element-checkbox v-model="processorData.steps[2].formData.have.value" :error="processorData.steps[2].formData.have.error" :label="processorData.steps[2].formData.have.label" :items="processorData.steps[2].formData.have.items" /></li>
          </ul>
        </element-processor-step>

        <element-processor-step :data="processorData.steps[3]">
          <include-estimate-auth-self :data="processorData.steps[0]" @updateprocessorData="updateprocessorData" />
        </element-processor-step>

        <element-processor-step :data="processorData.steps[4]">
          <ul class="form-item-list">
            <li class="is-multiple">
              <element-calendar v-model="processorData.steps[4].formData.consultDate.value" :error="processorData.steps[4].formData.consultDate.error" :label="processorData.steps[4].formData.consultDate.label" :placeholder="processorData.steps[4].formData.consultDate.placeholder" />
              <element-time-select v-model="processorData.steps[4].formData.consultTime.value" :date="processorData.steps[4].formData.consultDate.value" :error="processorData.steps[4].formData.consultTime.error" :label="processorData.steps[4].formData.consultTime.label" :placeholder="processorData.steps[4].formData.consultTime.placeholder" />
            </li>
            <li><element-textarea v-model="processorData.steps[4].formData.consultRemark.value" :error="processorData.steps[4].formData.consultRemark.error" :label="processorData.steps[4].formData.consultRemark.label" :placeholder="processorData.steps[4].formData.consultRemark.placeholder" /></li>
            <li><div class="form-item-caution">입력하신 내용을 바탕으로 상담원이 상담 전 확인 및 관련 내용을 준비하여 상담을 진행합니다.</div></li>
          </ul>
        </element-processor-step>
        <element-processor-step :data="processorData.steps[5]">
          <include-estimate-complete :data="processorData.steps[5]" />
        </element-processor-step>
        <element-processor-step :data="processorData.steps[6]">
          <include-other-estimate :data="processorData.steps[6]"  :type="processorData.title"/>
        </element-processor-step>
        <transition name="popup">
          <element-popup
            @status="popup"
            :process_title="processorData.title"
            v-model="processorData.steps[1].formData.insureOptions[statusPopup.option].value"
            @checkPopup="checkValue"
            :label="processorData.steps[1].formData.insureOptions[statusPopup.option].items[statusPopup.index].label"
            :subLabel="processorData.steps[1].formData.insureOptions[statusPopup.option].items[statusPopup.index].subLabel"
            v-if="statusPopup.popup"
            :statusPopup="statusPopup"
            :data="processorData.steps[1].formData.insureOptions[statusPopup.option]"
            :description="processorData.steps[1].formData.insureOptions[statusPopup.option].items[statusPopup.index].description">
          </element-popup>
        </transition>
      </element-processor>
    </div>
  </div>
</template>
<script>

import moment from 'moment'

export default {
  data(){
    return {
      statusPopup: {
        popup: false,
        index: '',
        option: -1,
        label: '',
      },
      moment: moment,
      processorData: {
        title: "실손의료보험 견적서",
        cureData: true,
        steps: [
          {
            title: "고객 정보",
            formData: {
              
              sex: {
                label: "성별",
                value: "남자",
                error: "",
                items: [
                  { value: "남자", label: "남자" },
                  { value: "여자", label: "여자" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              birth: {
                label: "생년월일",
                value: "",
                error: "",
                placeholder: "생년월일 8자리 입력",
                length: 8,
                validations: [
                  { type: "required", message: "필수항목입니다" },
                  { type: "birth", message: "예) 19950101" }
                ]
              },
              job: {
                label: "직업",
                value: "",
                error: "",
                items: [
                  { value: "사무,전문직", label: "사무,전문직" },
                  { value: "운수,건설직", label: "운수,건설직" },
                  { value: "판매,서비스직", label: "판매,서비스직" },
                  { value: "영업용 운전직", label: "영업용 운전직" },
                  { value: "학생,주부", label: "학생,주부" },
                  { value: "무직", label: "무직" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              }
            }
          },
          {
            title: "보장항목",
            formData:
            {
              title: "실손의료보험",
              insureDuration: {
                label: "보험 기간",
                value: "100세 만기 100세 납(보험료 1년 갱신, 상품 15년 갱신)",
                error: "",
                placeholder: "보험 기간 / 납입 기간을 선택하세요",
                items: [
                  { value: "100세 만기 100세 납(보험료 1년 갱신, 상품 15년 갱신)", label: "100세 만기 100세 납(보험료 1년 갱신, 상품 15년 갱신)" }
                ]
              },
              insureOptions: [
                {
                  label: "보장 내용",
                  requirement: true,
                  value: [
                    { label: "자기부담금", value: "표준형: 급여 및 비급여 20%, 추가특약 30%" },
                    { label: "상해 입원 및 수술비", value: "3,000만원" },
                    { label: "상해 통원 및 약제비", value: "통원 25만원, 약제 5만원" },
                    { label: "질병 입원 및 수술비", value: "3,000만원" },
                    { label: "질병 통원 및 약제비", value: "통원 25만원, 약제 5만원" },
                  ],
                  error: "",
                  items: [
                    { value: "자기부담금", label: "자기부담금", description: [
                      { value: "자기부담금을 선택합니다." },
                      { value: "급여란 국민건강보험 또는 의료급여법에 따라 보험금이 지급ㄷ괴는 대상이며, 비급여란 국민건강보험 또는 의료급여법에 따라 급여절차를 거쳤지만 급여가 지급되지 않는 대상입니다." }
                    ], subLabel: "표준형: 급여 및 비급여 20%, 추가특약 30%", useage: true, link: { name: "Home" },
                      options: [
                        { value: "표준형: 급여 및 비급여 20%, 추가특약 30%", label: "표준형: 급여 및 비급여 20%, 추가특약 30%" },
                        { value: "선택형: 급여 10%, 비급여 20%, 추가특약 30%", label: "선택형: 급여 10%, 비급여 20%, 추가특약 30%" },
                      ] },
                    { value: "상해 입원 및 수술비", label: "상해 입원 및 수술비", description: [
                      { value: "입원 및 수술치료비는 한 질병 당 보상 한도 금액이며, 3천만원과 5천만원의 보험료 차이가 크지 않아 5천만원을 많이 선택합니다." }
                    ], subLabel: "3,000만원", link: { name: "Home" },
                      options: [
                        { value: "5,000만원", label: "5,000만원" },
                        { value: "3,000만원", label: "3,000만원" },
                      ] },
                    { value: "상해 통원 및 약제비", label: "상해 통원 및 약제비", description: [
                      { value: "통원비는 365일간 180회 한도이며, 병원규모에 따라 한 회당 자기부담금이 1~2만원입니다" },
                      { value: "약제비는 365일간 180건 한도이며, 한 건당 자기부담금 8천원입니다." }
                    ], subLabel: "통원 25만원, 약제 5만원", link: { name: "Home" },
                      options: [
                        { value: "통원 25만원, 약제 5만원", label: "통원 25만원, 약제 5만" },
                        { value: "통원 20만원, 약제 10만원", label: "통원 20만원, 약제 10만원" },
                      ] },
                    { value: "질병 입원 및 수술비", label: "질병 입원 및 수술비", description: [
                      { value: "입원 및 수술 치료비는 한 질병 당 보상 한도 금액이며, 3천만원과 5천만원의 보험료 차이가 크지 않아 5천만원을 많이 선택합니다." }
                    ], subLabel: "3,000만원", link: { name: "Home" },
                      options: [
                        { value: "5,000만원", label: "5,000만원" },
                        { value: "3,000만원", label: "3,000만원" },
                      ] },
                    { value: "질병 통원 및 약제비", label: "질병 통원 및 약제비", description: [
                      { value: "통원비는 365일간 180회 한도이며, 병원규모에 따라 한회당 자기부담금이 1~2만원입니다." },
                      { value: "약제비는 365일간 180건 한도이며, 한 건당 자기부담금 8천원입니다." }
                    ], subLabel: "통원 25만원, 약제 5만원", link: { name: "Home" },
                      options: [
                        { value: "통원 25만원, 약제 5만원", label: "통원 25만원, 약제 5만원" },
                        { value: "통원 20만원, 약체 10만원", label: "통원 20만원, 약체 10만원" },
                      ] },
                  ],
                },
                {
                  label: "추가 특약",
                  requirement: false,
                  value: [
                    { label: "비급여 도수·체외 충격파·증식 치료비", value: "300만원" },
                    { label: "비급여 주사비", value: "250만원" },
                    { label: "비급여 자기공명영상(MRI/MRA) 진단비", value: "300만원" },
                  ],
                  error: "",
                  items: [
                    {
                      value: "비급여 도수·체외 충격파·증식 치료비",
                      label: "비급여 도수·체외 충격파·증식 치료비",
                      description: [
                        {
                          value: "도수·체외충격파·증식 치료비는 365일간 50회 한도이며, 한 회당 자기부담금이 보상대상의료비의 30%(최소 2만원)입니다."
                        }
                      ],
                      subLabel: "300만원",
                      link: {
                        name: "Home"
                      },
                      options: [
                        { value: "300만원", label: "300만원" },
                        { value: "미가입", label: "미가입" },
                      ]
                    },
                    { value: "비급여 주사비", label: "비급여 주사비", description: [
                      { value: "비급여 주사비는 365일간 50회 한도이며, 한 회당 자기부담금이 보상대상의료비의 30%(최소 2만원)입니다." }
                    ], subLabel: "250만원", link: { name: "Home" },
                      options: [
                        { value: "250만원", label: "250만원" },
                        { value: "미가입", label: "미가입" },
                      ] },
                    { value: "비급여 자기공명영상(MRI/MRA) 진단비", label: "비급여 자기공명영상(MRI/MRA) 진단비", description: [
                      { value: "비급여 자기공명영상 진단비는 365일간 보장시 한도 금액이며, 한 회당 자기부담금이 보상대상의료비의 30%(최소 2만원)입니다." }
                    ], subLabel: "300만원", link: { name: "Home" },
                      options: [
                        { value: "300만원", label: "300만원" },
                        { value: "미가입", label: "미가입" },
                      ] },
                  ]
                },
                {
                  label: '추천 특약',
                  requirement: true,
                  value: [],
                  error: "",
                  items: [
                    {
                      value: "암 진단금",
                      label: "암 진단금",
                      description: [
                        {
                          value: "암 진단금이며 1개의 증권에 1천만원부터 1억까지 가입이 가능합니다. 1억 이상 진단금 받기를 원하는 경우에는 두 개의 보험사로 나누어서 가입하는 방법이 있습니다."
                        }
                      ],
                      subLabel: "미가입",
                      link: {
                        name: "Home"
                      },
                      options: [
                        { value: "1000만원", label: "1000만원" },
                        { value: "2000만원", label: "2000만원" },
                        { value: "3000만원", label: "3000만원" },
                        { value: "3000만원 이상", label: "3000만원 이상" },
                        { value: "미가입", label: "미가입" },
                      ]
                    },
                    {
                      value: "심혈관 진단금",
                      label: "심혈관 진단금",
                      description: [
                        {
                          value: "심혈관 진단금은 급성심근경색 및 허혈성심장으로 진단시 지급 받는 보험급입니다."
                        }
                      ],
                      subLabel: "미가입",
                      link: {
                        name: "Home"
                      },
                      options: [
                        { value: "1000만원", label: "1000만원" },
                        { value: "2000만원", label: "2000만원" },
                        { value: "3000만원", label: "3000만원" },
                        { value: "3000만원 이상", label: "3000만원 이상" },
                        { value: "미가입", label: "미가입" },
                      ]
                    },
                    {
                      value: "뇌혈관 진단금",
                      label: "뇌혈관 진단금",
                      description: [
                        {
                          value: "뇌혈관 진단금은 뇌졸증 및 뇌출혈으로 진단시 지급 받는 보험금입니다."
                        }
                      ],
                      subLabel: "미가입",
                      link: {
                        name: "Home"
                      },
                      options: [
                        { value: "1000만원", label: "1000만원" },
                        { value: "2000만원", label: "2000만원" },
                        { value: "3000만원", label: "3000만원" },
                        { value: "3000만원 이상", label: "3000만원 이상" },
                        { value: "미가입", label: "미가입" },
                      ]
                    },
                    {
                      value: "질병사망",
                      label: "질병사망",
                      description: [
                        {
                          value: "질병사망은 질병을 직접적인 원인으로 사망하는 경우 지급 받는 보험금입니다."
                        }
                      ],
                      subLabel: "미가입",
                      link: {
                        name: "Home"
                      },
                      options: [
                        { value: "1000만원", label: "1000만원" },
                        { value: "2000만원", label: "2000만원" },
                        { value: "3000만원", label: "3000만원" },
                        { value: "3000만원 이상", label: "3000만원 이상" },
                        { value: "미가입", label: "미가입" },
                      ]
                    },
                    {
                      value: "질병후유장애",
                      label: "질병후유장애",
                      description: [
                        {
                          value: "질병후유장애는 질병으로 인하여 치유된 후 신체에 남아있는 영구적인 정신 또는 육체의 훼손 및 기능을 상실한 경우 지급 받는 보험금입니다. 보험금은 약관에 명시된 장해분류표를 기준으로 3~80%까지 비례하여 지급됩니다."
                        }
                      ],
                      subLabel: "미가입",
                      link: {
                        name: "Home"
                      },
                      options: [
                        { value: "1000만원", label: "1000만원" },
                        { value: "2000만원", label: "2000만원" },
                        { value: "3000만원", label: "3000만원" },
                        { value: "3000만원 이상", label: "3000만원 이상" },
                        { value: "미가입", label: "미가입" },
                      ]
                    },
                  ],
                  validations: [
                    { type: "required", message: "보험사의 인수심사 기준에 따르면 추천 특약을 하나 이상 가입해야 실손 보험가입이 가능합니다." }
                  ]
                }
              ]
            }
          },
          {
            title: "치료이력",
            formData: {
              name: {
                label: "이름",
                value: "",
                error: "",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              birth: {
                label: "생년월일",
                value: "",
                error: "",
                placeholder: "생년월일 6자리 입력",
                validations: [
                  { type: "required", message: "필수항목입니다" },
                  { type: "birth", message: "예) 950101" },
                ]
              },
              history: {
                label: "최근 3개월 이내 질병 또는 상해로 약을 먹거나 치료한 경험이 있습니까?",
                value: "",
                error: "",
                items: [
                  { value: "치료", label: "치료" },
                  { value: "검사", label: "검사" },
                  { value: "없음", label: "없음" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              inject: {
                label: "최근 5년 이내 입원, 수술 혹은 30일 이상 투약한 경험이 있습니까?",
                value: "",
                error: "",
                items: [
                  { value: "2년 이내", label: "2년 이내" },
                  { value: "2~5년", label: "2~5년" },
                  { value: "없음", label: "없음" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              have: {
                label: "관리하고 있는 질병이 있습니까?",
                value: "",
                error: "",
                items: [
                  { value: "당뇨병", label: "당뇨병" },
                  { value: "고혈압", label: "고혈압" },
                  { value: "고지혈증", label: "고지혈증" },
                  { value: "뇌혈관질환", label: "뇌혈관질환" },
                  { value: "심혈관질환", label: "심혈관질환" },
                  { value: "없음", label: "없음" },
                ],
                validations: [
                  { type: "array", message: "필수항목입니다" }
                ]
              },
            }
          },
          {
            title: "본인 확인",
            formData: {
              // haslogin: {
              //   value: "",
              //   validations: [
              //     { type: "required", message: "-" }
              //   ]
              // },
              phone: {
                label: "휴대폰 번호",
                value: "",
                validations: [
                  { type: "required", message: "-" }
                ]
              },
              name: {
                label: "이름",
                value: "",
                validations: [
                  { type: "required", message: "-" }
                ]
              },
              email: {
                label: "이메일",
                value: "",
                // validations: [
                //   { type: "required", message: "-" }
                // ]
              },
              birth: {
                label: "생년월일",
                value: "",
                validations: [
                  { type: "required", message: "-" },
                ]
              },
            }
          },
          {
            title: "상담 예약",
            formData: {
              consultDate: {
                label: "상담 예약 일시",
                value: new Date(),
                error: "",
                placeholder: "날짜"
              },
              consultTime: {
                label: "상담 예약 일시",
                value: "",
                error: "",
                placeholder: "시간",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              consultRemark: {
                label: "상담 전 남기실 말씀",
                value: "",
                error: "",
                placeholder: "특별히 보장 받고 싶은 보장 항목, 기간, 금액 또는 현재 가입 중인 보험 그리고 상담 전 남기실 말씀을 입력하십시오. (200자 이내)"
              },
            }
          },
          {
            title: "비교견적 신청이 완료되었습니다.",
            label: "입력하신 정보를 바탕으로 쉽게 추가 견적서를 신청하시겠습니까?"
          },
          {
            title: "다른 보험 표준 견적서 받아보기",
            label: "",
            value: []
          }
        ] // steps
      }
    }
  },
  created() {
    const { date, time } = this.$getDefaultConsultTime();

    if (date !== '') {
      this.processorData.steps[4].formData.consultDate.value = date;
    }

    this.processorData.steps[4].formData.consultTime.value = time;
  },
  methods: {
    submit( finalData ) {
      var tmp = JSON.parse(JSON.stringify(finalData["상담 예약"]));
      // 상담 예약 제거
      delete finalData["상담 예약"];
      //가입자 , 자필서명
      if(this.$route.query) {
        if(this.$route.query.procstep == "가입자" || this.$route.query.procstep == "본인 확인" || this.$route.query.procstep == "자필서명") {
          this.$store.dispatch( "estimate/createItems", finalData);
        }else if(this.$route.query.procstep == "상담 예약") {
          tmp.step_datas.insureName = { value: finalData.title }
          tmp.step_datas.name = {  value: this.processorData.steps[3].formData.name.value }
          tmp.step_datas.phone = { value: this.processorData.steps[3].formData.phone.value}
          var reservation_data = {
            customer_id: finalData.customer_id,
            "전화상담": tmp
          }
          // 전화상담 예약 전송
          this.$store.dispatch( "reservation/createItems", reservation_data );
        }
      }
    },
    popup: function( status ) {
      this.statusPopup = status;
    },
    checkValue: function( value ) {
      var insureOptionsObj = this.processorData.steps[1].formData.insureOptions[this.statusPopup.option];
      insureOptionsObj.items[this.statusPopup.index].subLabel = value;
      const label = (insureOptionsObj.items.find(o => o.label === this.statusPopup.label) || { label: '' }).label;

      var Vidx = insureOptionsObj.value.findIndex(o => o.label === label);
      if(Vidx >= 0){
        if(value === '미가입' && !insureOptionsObj.requirement){
          // 필수 보장항목이 아니고, 미가입하는경우는 value 목록에서 제거
          insureOptionsObj.value.splice(Vidx, 1);
        }else{
          // 이외 값 변경
          // 단, 값이 Array 인경우가 있으므로 확인 ( 다중선택 가능한경우 )
          if(Array.isArray(insureOptionsObj.value[Vidx].value)) {
            var VIidx = insureOptionsObj.value[Vidx].value.indexOf(value);
            // 이미 arr 값이 있는경우 제거
            if(VIidx >= 0){
              //단, 최소 하나이상 선택하도록 해야하므로
              if(insureOptionsObj.value[Vidx].value.length > 0) insureOptionsObj.value[Vidx].value.splice(VIidx, 1);
            }else{
              // 추가
              insureOptionsObj.value[Vidx].value.push(value)
            }
            insureOptionsObj.items[this.statusPopup.index].subLabel = insureOptionsObj.value[Vidx].value.join();
          }else{            
            insureOptionsObj.value[Vidx].value = value;
          }
        }
      }else{
        // value 목록에 없는 경우
        if(value != '미가입'){
          // 미가입 아닌경우 값 추가
          var tmp = { label: insureOptionsObj.items[this.statusPopup.index].value, value: value };
          insureOptionsObj.value.push( tmp )
        }
      }
    },
    updateprocessorData: function (data){
      //this.processorData.steps[3].formData.haslogin.value = data.haslogin;
      this.processorData.steps[3].formData.phone.value = data.phone;
      this.processorData.steps[3].formData.name.value = data.name;
      this.processorData.steps[3].formData.email.value = data.email;
      this.processorData.steps[3].formData.birth.value = data.birth;
    },
    submitOtherEst() {
      var tmp = {
        customer_id: this.$store.state.customer.profile._id,
        "전화상담": {
          step_datas: {
            insureName: { value: "" },
            name: {  value: this.processorData.steps[3].formData.name.value },
            phone: { value: this.processorData.steps[3].formData.phone.value },
            consultDate: { value: this.processorData.steps[this.processorData.steps.length - 3].formData.consultDate.value },
            consultTime: { value: this.processorData.steps[this.processorData.steps.length - 3].formData.consultTime.value },
            consultRemark: { value: this.processorData.steps[this.processorData.steps.length - 3].formData.consultRemark.value ? this.processorData.steps[this.processorData.steps.length - 3].formData.consultRemark.value : "없음"}
          }
        }
      }
      var ost_data = this.processorData.steps[this.processorData.steps.length - 1];
      if(ost_data.value.length > 0) {
        ost_data.value.forEach(o => {
          tmp["전화상담"].step_datas.insureName.value = o
          this.$store.dispatch( "reservation/createItems", tmp );
        })
      }
    }
  }
}
</script>
